import { useLocalParticipant } from "@livekit/components-react";
import { useEffect } from "react";
import { applyMicrophoneBitrate } from "../lib/apply-microphone-bitrate";
import { useConferenceSettingsStore } from "./conference-settings.store";

/**
 * Синхронизирует выбранное качество аудио с уже опубликованным микрофоном.
 * Должен быть отрендерен внутри LiveKitRoom. Комнату не пересоздаёт:
 * битрейт меняется напрямую в параметрах sender'а (см. applyMicrophoneBitrate).
 */
export const MicrophoneBitrateSync = () => {
  const { localParticipant, microphoneTrack } = useLocalParticipant();
  const { selectedAudioBitrate } = useConferenceSettingsStore();

  useEffect(() => {
    if (!localParticipant || !microphoneTrack?.track) {
      return;
    }

    // Идемпотентно: повторное применение того же maxBitrate безвредно,
    // а при публикации микрофона после смены настройки подхватит актуальное значение
    void applyMicrophoneBitrate(localParticipant, selectedAudioBitrate);
  }, [localParticipant, microphoneTrack, selectedAudioBitrate]);

  return null;
};
